import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {modalContents} from '../modal-contents';
import HTMLUtil from '../utils/htmlUtil';

const LOCALE = {
    "unavailable": {
        fr: "Non disponible",
        en: "Not available"
    },
    "loading": {
        fr: "Chargement...",
        en: "Loading..."
    },
    "close": {
        fr: "Fermer",
        en: "Close"
    },
    "print": {
        fr: "Imprimer",
        en: "Print"
    }
};

class Modal extends Component {
    constructor(props) {
        super(props);

        this._onShowHandler = this._onShowHandler.bind(this);
        this._onHideHandler = this._onHideHandler.bind(this);
        this._getContent = this._getContent.bind(this);
        this._getHtmlContent = this._getHtmlContent.bind(this);
        this._fetchHtmlContentAndSetState = this._fetchHtmlContentAndSetState.bind(this);
        
        this.state = {
            title: "",
            url: "",
            htmlContent: "",
            content: "",
            printable: false
        };
    }

    render() {
        return (
        <div id={this.props.id||"modal-window"} className="modal fade bound" tabIndex="-1" role="dialog" aria-labelledby="modal-titre" aria-hidden="true">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header bg-vert">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                        <h4 className="modal-title text-blanc text-bold">{this._getTitle()}</h4>
                    </div>
                    <div className="modal-body texte_petit" ref={(el) => this.contentWrapper = el}>
                        {this._getHtmlContent()}
                        {this._getContent()}
                    </div>
                    <div className="modal-footer">
                        {
                            (this.state.printable === true?<button className="btn btn-default bg-vert-hover">{LOCALE.print[this.props.lang]}</button>:null)
                        }
                        <button type="button" className="btn btn-default bg-vert-hover" data-dismiss="modal">{LOCALE.close[this.props.lang]}</button>
                    </div>
                </div>
            </div>
        </div>
        );
    }

    componentDidMount() {
        window.$('#'+this.props.id).modal({show:false});
        window.$('#'+this.props.id).on('show.bs.modal', this._onShowHandler);
        window.$('#'+this.props.id).on('hide.bs.modal', this._onHideHandler);
    }

    _getTitle() {
        if (this.state.title)
        {
            return this.state.title;
        }
        else if (this.state.content)
        {
            return modalContents[this.state.content][this.props.lang].title;
        }
    }

    _getHtmlContent() {
        if (this.state.htmlContent)
        {
            return <div dangerouslySetInnerHTML={HTMLUtil.getHTMLTextForReact(this.state.htmlContent)} />
        }
    }

    _getContent() {
        if (this.state.content)
        {
            return modalContents[this.state.content][this.props.lang].content;
        }
        else if (this.state.htmlContent === "")
        {
            return LOCALE["loading"][this.props.lang];
        }
    }

    _onShowHandler(e) {
        
        let elem = window.$(e.relatedTarget);

        let newState = {
            title: elem.attr("data-title")||"",
            content: elem.attr("data-content")||"",
            printable: elem.attr("data-printable")||false,
        };
        
        if (elem.attr("data-url"))
        {
            Object.assign(newState,{url: elem.attr("data-url"), htmlContent: "", content: ""});
            this._fetchHtmlContentAndSetState(elem.attr("data-url"),newState);
        }
        else if (elem.attr("data-content"))
        {
            Object.assign(newState,{url:"", htmlContent: "", content: elem.attr("data-content")});
            this.setState(newState);
        }
    }

    _onHideHandler() {
        this.setState({content:"",htmlContent:"",url:"",title:""});
    }

    _fetchHtmlContentAndSetState(urlToFetch,newState) {
        let [url,anchor] = urlToFetch.split(" ");

        fetch(url)
        .then(resp => resp.text())
        .then(data => {
            let htmlContent = "";

            if (anchor)
            {
                htmlContent = window.$(`<section>${data}</section>`).find(anchor).html();
            }
            else
            {
                htmlContent = window.$(`<section>${data}</section>`).html();
            }

            Object.assign(newState,{htmlContent: (window.$(htmlContent).text()) ? htmlContent : LOCALE["unavailable"][this.props.lang]});
            this.setState(newState);
        })
        .catch(error => {
            console.error("Problèmes: fetchModalUrlContent", error);
        });
    }
}

Modal.defaultProps = {
    id: "modal-window",
    lang: "fr"
}

Modal.propTypes = {
    id: PropTypes.string.isRequired
};

export default Modal;